import { render, staticRenderFns } from "./deleteReportCustomComponent.vue?vue&type=template&id=b90877d2"
import script from "./deleteReportCustomComponent.vue?vue&type=script&lang=js"
export * from "./deleteReportCustomComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports